import { Modal } from '@toggle/design-system';
import React, { ReactNode } from 'react';

import styles from './ChartModal.module.scss';

interface ChartModalProps {
  isOpen: boolean;
  title: ReactNode;
  downloadButton: ReactNode;
  chart: ReactNode;
  onClose: () => void;
}

export const ChartModal = ({
  isOpen,
  title,
  downloadButton,
  chart,
  onClose,
}: ChartModalProps) => {
  return (
    <Modal
      className={styles.styledModal}
      isOpen={isOpen}
      title={title}
      onClose={onClose}
    >
      <div className={styles.buttonWrapper}>{downloadButton}</div>
      <div className={styles.contentWrapper}>
        <div>{chart}</div>
      </div>
    </Modal>
  );
};
